import { useVenueDataContext } from '@/VenueDataLoader'

export function useWidgetSettings() {
  const { widgetSettings } = useVenueDataContext()
  return widgetSettings
}
